module.exports = __webpack_public_path__ + "c4738aacde781e5d6642532666ee476c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox_failed.png
// module id = 23
// module chunks = 0 1 2 3 4